import { Routes } from '@angular/router';
import { SOFTLINE_PERMISSION_ARTIKELSTAMM } from './artikelstamm.shared';
import { askFn } from '@softline/ui-core';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { ProductRepository } from './repositories/product.repository';
import { ProductService } from './services/product.service';
import { SalesPriceService } from './services/sales-price.service';
import { SalesPriceRepository } from './repositories/sales-price.repository';
import { SalesPromotionRepository } from './repositories/sales-promotion.repository';
import { SupplierRepository } from './repositories/supplier.repository';
import { SupplierPriceRepository } from './repositories/supplier-price.repository';
import { SupplierPriceService } from './services/supplier-price.service';
import { SupplierPromotionRepository } from './repositories/supplier-promotion.repository';
import { SupplierPromotionService } from './services/supplier-promotion.service';
import { UnitRepository } from './repositories/unit.repository';
import { ProductDescriptionRepository } from './repositories/product-description.repository';
import { SalesPromotionQueryService } from './services/sales-promotion-query.service';
import { SalesPriceQueryService } from './services/sales-price-query.service';
import { SupplierPromotionQueryService } from './services/supplier-promotion-query.service';

export const artikelstammRoutes: Routes = [
  {
    path: 'artikelstamm',
    children: [
      {
        path: ':id',
        loadComponent: () =>
          import('./pages/artikel-detail/artikel-detail.component'),
        canDeactivate: [
          async (component: { unsavedChanges: () => never }) => {
            const ask = askFn();
            if (component.unsavedChanges()) {
              const result = await ask({
                question:
                  'Sie haben ungespeicherte Änderungen. Möchten Sie die Seite wirklich verlassen?',
              });
              if (
                !result ||
                result === 'NO' ||
                result === 'CANCEL' ||
                result === 'DISMISSED'
              ) {
                return false;
              }
            }
            return true;
          },
        ],
        providers: [
          ProductService,
          ProductRepository,
          SalesPriceRepository,
          SalesPriceService,
          SalesPriceQueryService,
          SalesPromotionRepository,
          SalesPromotionQueryService,
          SupplierRepository,
          SupplierPriceRepository,
          SupplierPriceService,
          SupplierPromotionRepository,
          SupplierPromotionService,
          SupplierPromotionQueryService,
          UnitRepository,
          ProductDescriptionRepository,
        ],
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/artikelsuche/artikelsuche.component')
      },
      {
        path: '**',
        redirectTo: '/artikelstamm',
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_ARTIKELSTAMM },
    providers: [
      ProductRepository,
    ]
  },
];
